'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/shared/components/ui';
interface FalhaAoCarregarRegistroProps {
  mensagem: string;
  onTentarDeNovo: () => void;
}

/**
 * O registro de anexos não chegou (ou chegou sem o que deveria ter): a mensagem e o "Tentar de
 * novo". Serve o bloco dos anexos fora do PDF e o registro completo da Secretaria.
 */
export function FalhaAoCarregarRegistro(t0) {
  const $ = _c(7);
  const {
    mensagem,
    onTentarDeNovo
  } = t0;
  let t1;
  if ($[0] !== mensagem) {
    t1 = <span className="text-[12.5px] text-neutral-700">{mensagem}</span>;
    $[0] = mensagem;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onTentarDeNovo) {
    t2 = <Button onClick={onTentarDeNovo} variant="neutral-secondary">Tentar de novo</Button>;
    $[2] = onTentarDeNovo;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col items-start gap-2" role="alert">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}